import { restfulClient } from '@/api'

export const storeListApi = {
  path: 'store',
  async paging(query = {}) {
    return restfulClient.getCollection(this.path, query)
  },
  async update(id, query = {}) {
    return await restfulClient.update(this.path, id, query)
  },
  async remove(id) {
    return await restfulClient.remove(this.path, id)
  }
}

export const downStoreTemplateApi = {
  path: 'store/download-template'
}

export const exportStoreApi = {
  path: 'store/excel',
  async get(query = {}) {
    return await restfulClient.getCollection(this.path, query)
  }
}
export const exportVideoDownloadApi = {
  path: 'video/download',
  async get(query = {}) {
    return await restfulClient.getCollection(this.path, query)
  }
}
